import { render, staticRenderFns } from "./OListActions.vue?vue&type=template&id=00ff2bfa&"
import script from "./OListActions.vue?vue&type=script&lang=js&"
export * from "./OListActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports